import React from 'react';
import PropTypes from 'prop-types';

import PDPAlertBar from 'components/consumer/PDP/PDPAlertBar';
import useSetPdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/useSetPdpSelectedCustomizerTab';
import { PDP_CUSTOMIZE_TAB_ID } from 'commons/constants';

const PDPSelectionAlert = ({ selectionValidity = '' }) => {
  const setPdpSelectedCustomizerTab = useSetPdpSelectedCustomizerTab();

  return (
    <PDPAlertBar type="error">
      <span>Unavailable for ready to ship.</span>

      {selectionValidity === 'invalid' ? (
        <span>
          &nbsp;Get this by{' '}
          <button
            type="button"
            className="font-bold underline [background:none] border-0"
            onClick={() => setPdpSelectedCustomizerTab(PDP_CUSTOMIZE_TAB_ID)}
          >
            going custom
          </button>
          .
        </span>
      ) : null}
    </PDPAlertBar>
  );
};

PDPSelectionAlert.propTypes = {
  selectionValidity: PropTypes.string,
};

export default PDPSelectionAlert;
